import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthenticationService } from '../authentication/authentication.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CredentialsService } from '../authentication/credentials.service';
import { UserRoles } from '../shared/models/user.interface'
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-login',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit {
  public isVillageStaff: any;
  public isAdmin: any;
  public isOfficer: any;
  public headerName: string;
  signInForm: FormGroup;
  private currentLogin: any;
  public isEnable: boolean = false;
  public activeParam;
  public showSpinner: boolean = false;
  @ViewChild('passwordField') passwordField: ElementRef;
  showPassword = false;
  changeCount = 0;
  constructor(
    private activeRouter: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private _snackBar: MatSnackBar,
    private credentialService: CredentialsService,
    public dialog: MatDialog,
    //  private routeSubscription: Subscription

  ) {
    // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
       window.location.hash="";
    window.location.hash="";//again because google chrome don't insert first hash into history
    window.onhashchange=function(){window.location.hash="";}
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit(): void {
    this.activeRouter.params.subscribe(params => {
      // setCurrentWaiver(waiver: any) {
      //   this.waiver_vehicle_id = waiver.waiver_vehicle_id;
      //     this.currentWaiver.next(waiver);
      // }
      this.authenticationService.setCurrentLogin(params);
      this.activeParam = params;
      this.isAdmin = params.isAdmin;
      this.isOfficer = params.isOfficer;
      this.isVillageStaff = params.isVillageStaff;

      if (this.isAdmin == UserRoles.ADMIN) {
        this.headerName = 'Admin Login';
        this.currentLogin = this.isAdmin;
      }
      if (this.isOfficer == UserRoles.OFFICER) {
        this.headerName = 'Officer Login';
        this.currentLogin = this.isOfficer;
      }
      if (this.isVillageStaff == UserRoles.STAFF)
        this.headerName = 'Village Staff Login';
      this.currentLogin = this.isVillageStaff;
    });

    this.signInForm = this.formBuilder.group({
      userName: ['', Validators.required],
      password: ['', Validators.required],
    });

    if (this.credentialService.isAuthenticated()) {
      this.currentLogin = this.authenticationService.getCurrentLogin();
      const currentUserLogin = this.authenticationService.getHomeUrl(this.currentLogin);
      if (currentUserLogin !== undefined) {
        this.router.navigate([currentUserLogin], { replaceUrl: true }); return;
      }
    }
    // this.signInForm.controls['password'].setValue(this.signInForm.controls['password'].value);
    this.signInForm.controls['password'].valueChanges.subscribe(
      (value: any) => {
        this.changeCount++;
      }
    );
    // this.initIoConnection();
  }

  // private initIoConnection(): void {
  //   this.socketService.initSocket();
  // }
  onSubmit() {
    this.showSpinner = true;
    if (this.signInForm.value.email == '' || this.signInForm.value.password == '') {
      this._snackBar.open('Error :' + 'Please Enter the right credentials', '', {
        duration: 3000,
        verticalPosition: 'bottom',
        horizontalPosition: 'right',
        panelClass: 'error-snackbar'
      });
      this.showSpinner = true;
      return true;
    }
    if (this.isAdmin) {
      // if (this.signInForm.value.userName == 'vov-admin@blackstraw.ai') {
      //   this.authenticationService.adminSignIn(this.signInForm.value).subscribe((credentials) => {
      //     if (credentials.user.sessionToken && credentials.user.auth == 'true') {
      //       this.credentialService.setCredentials(credentials.user).then((sucess) => {
      //         this.currentLogin = this.authenticationService.getCurrentLogin();
      //         this.router.navigate([this.authenticationService.getHomeUrl(this.currentLogin)], { replaceUrl: true });
      //       }).catch((err) => console.log(err));
      //     }
      //   }, error => {
      //     let errorMessage: string;
      //     if (error.error.message) {
      //       errorMessage = error.error.message;
      //     } else {
      //       errorMessage = `${error.message}`;
      //     }
      //     console.log(error);
      //     this._snackBar.open('Error :' + errorMessage, '', {
      //       duration: 3000,
      //       verticalPosition: 'bottom',
      //       horizontalPosition: 'right',
      //       panelClass: 'error-snackbar'
      //     });
      //   });
      // } else {
      this.authenticationService.signIn(this.signInForm.value).subscribe((credentials) => {
        let user = credentials.user;
        const adminRole = user.userRoles.filter(u => u.roleId == UserRoles.ADMIN);
        this.currentLogin = this.authenticationService.getCurrentLogin();
        if (this.currentLogin.isAdmin && adminRole.length == 0) {
          this._snackBar.open('Warning :' + 'This user is not associated to admin role, please contact support', '', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'right',
            panelClass: 'warning-snackbar'
          });
          this.showSpinner = false;
          return;
        }
        if (user.sessionToken && user.auth == 'true') {
          this.credentialService.setCredentials(credentials.user).then((sucess) => {
            console.log(sucess);
            this.showSpinner = false;
            // this.router.navigate(['/vehicle-search']);
            this.router.navigate([this.authenticationService.getHomeUrl(this.currentLogin)], { replaceUrl: true });
          }).catch((err) => console.log(err));
        }
      }, error => {
        const errorMessage = (error && error.error && error.message) ? error.error.message : error.statusText;
        this._snackBar.open('Error :' + errorMessage, '', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'right',
          panelClass: 'error-snackbar'
        });
        this.showSpinner = false;
      });
     
      // }

    } else {
      this.authenticationService.signIn(this.signInForm.value).subscribe((credentials) => {
        let user = credentials.user;
        this.showSpinner = false;
        const officerRole = user.userRoles.filter(u => u.roleId == UserRoles.OFFICER || u.roleId == UserRoles.ADMIN);
        this.currentLogin = this.authenticationService.getCurrentLogin();
        if (this.currentLogin.isOfficer && officerRole.length == 0) {
          this._snackBar.open('Warning :' + 'This user is not associated to officer role, please contact support', '', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'right',
            panelClass: 'warning-snackbar'
          });
          this.showSpinner = false;
          return;
        }
        console.log(user, 'userr')
        const staffRole = user.userRoles.filter(u => u.roleId == UserRoles.STAFF || u.roleId == UserRoles.ADMIN);
        console.log(staffRole, 'roleee')
        if (this.currentLogin.isVillageStaff && staffRole.length == 0) {
          this._snackBar.open('Warning :' + 'This user is not associated to village staff role, please contact support', '', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'right',
            panelClass: 'warning-snackbar'
          });
          this.showSpinner = false;
          return;
        }

        const adminRole = user.userRoles.filter(u => u.roleId == UserRoles.STAFF);
        if (this.currentLogin.isAdmin && adminRole.length == 0) {
          this._snackBar.open('Warning :' + 'This user is not associated to admin Role, please contact support', '', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'right',
            panelClass: 'warning-snackbar'
          });
          this.showSpinner = false;
          return;
        }

        if (user.userRoles == null && user.sessionToken && user.auth == 'true') {
          this._snackBar.open('Error :' + 'This user is not associated to any role, please contact support', '', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'right',
            panelClass: 'error-snackbar'
          });
          this.showSpinner = false;
          return;
        }
        // if (user.userRoles[0]. && user.sessionToken && user.auth == 'true') {
        //   this._snackBar.open('Error :' + 'This user is not associated to any role, please contact support', '', {
        //     duration: 3000,
        //     horizontalPosition: 'right',
        //     panelClass: 'error-snackbar'
        //   });
        //   return;
        // }
        if (user.sessionToken && user.auth == 'true') {
          this.credentialService.setCredentials(credentials.user).then((sucess) => {
            console.log(sucess);
            this.showSpinner = false;
            // this.router.navigate(['/vehicle-search']);
            this.router.navigate([this.authenticationService.getHomeUrl(this.currentLogin)], { replaceUrl: true });
          }).catch((err) => console.log(err));
        }
      }, error => {
        const errorMessage = (error && error.error && error.message) ? error.error.message : error.statusText;
        this._snackBar.open('Error :' + errorMessage, '', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'right',
          panelClass: 'error-snackbar'
        });
        this.showSpinner = false;
      });
    }

  }


  reset() {
    this.signInForm.reset();
    this.showPassword = false;
    this.passwordField.nativeElement.setAttribute('type', 'password');
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
    if (this.showPassword) {
      this.passwordField.nativeElement.setAttribute('type', 'text');
    } else {
      this.passwordField.nativeElement.setAttribute('type', 'password');
    }
  }
  gotoVehicleDetails() {
    this.router.navigate(['/officer', { isVillageStaff: this.isVillageStaff }])
  }

  forgotPassword() {
    this.router.navigate(['/forgot-pwd', this.activeParam])
  }

  // navigation links
  gotoOfficer() {
    this.router.navigate(['/sign-in', { isOfficer: UserRoles.OFFICER }], { replaceUrl: true })
    this.isEnable = true;
  }
  gotoAdmin() {
    this.router.navigate(['/sign-in', { isAdmin: UserRoles.ADMIN }], { replaceUrl: true })
    this.isEnable = true;
  }
  gotoVillageStaff() {
    const isVillageStaff = true;
    this.router.navigate(['/sign-in', { isVillageStaff: UserRoles.STAFF }], { replaceUrl: true });
    this.isEnable = true;
  }
  // goHome(){
  //   this.router.navigate(['/home']);
  // }
}

